export { default } from './InstallationPricingConnector';

